import TrustpilotWidget from './TrustpilotWidget';

export default TrustpilotWidget;
